import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from '../../../component/shared.module';
import { CostCalculationModule } from '../cost-calculation/cost-calculation.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClaimByProjectRoutingModule } from './claim-by-project-routing.module';
import { ClaimByProjectComponent } from './claim-by-project.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    ClaimByProjectRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    SharedModule,
    CostCalculationModule,
    NgSelectModule,
    FormsModule,
    MatIconModule
  ],
  
  declarations: [ClaimByProjectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClaimByProjectModule {}
